import React from "react";
import {
  Tooltip,
  WithTooltip,
  Dropdown,
  DropdownOption,
  Dialog,
} from "@abb/abb-common-ux-react";
import { v4 as uuidv4 } from "uuid";

import * as CONSTANTS from "../../utilities/Constants";
import SampleViewData, {
  defaultSampleData,
  ISampleViewData,
} from "../../models/sample/SampleViewData";
import { Translation } from "react-i18next";
import "../../utilities/Extensions";
import measurementActions from "../../flux/actions/MeasurementActions";
import MeasurementRejectStore from "../../flux/stores/measurement/MeasurementRejectStore";
import MeasurementApproveStore from "../../flux/stores/measurement/MeasurementApproveStore";
import triggerNotifications from "../../utilities/TriggerNotifications";
import History from "../../utilities/History";
import SampleOverviewStore from "../../flux/stores/sample/OverviewStore";
import {
  ISampleOverviewData,
  defaultSampleOverviewData,
} from "../../models/sample/SampleOverviewData";
import {
  IEditSampleMeasurement,
  IPropertyDetail,
  InitiaDataReq,
} from "../../models/sample/EditSampleMeasuredData";
import { SampleGradeProductFormData } from "../../models/shared/SampleGradeProductFormData";
import productActions from "../../flux/actions/ProductActions";
import gradeActions from "../../flux/actions/GradeActions";
import gradeFormStore from "../../flux/stores/grade/FormStore";
import productFormStore from "../../flux/stores/product/FormStore";
import sampleActions from "../../flux/actions/SampleActions";
import sampleReportStore from "../../flux/stores/sample/ReportStore";
import { Icon } from "@abb/abb-common-ux-react";
import { ABB_CARET_DOWN, ABB_CARET_RIGHT } from "../../utilities/IconConstants";
import {
  IReportPropertyData,
  PropertyType,
} from "../../models/sample/ReportProperties";
import measuredPositionStore from "../../flux/stores/sample/MeasuredPositionsStore";
import calculatedPositionStore from "../../flux/stores/sample/CalculatedPositionStore";
import keyedInPositionStore from "../../flux/stores/sample/KeyedInPositionStore";
import sampleMeasurementEditStore from "../../flux/stores/sample/SampleMeasurementEditStore";
import _ from "lodash";
import {
  ChartTypes,
  DateUnits,
  ISeries,
  ITrendDataLimit,
  Trend,
  TrendMarkerTypes,
} from "@iom/trend";
import measurementSettingStore from "../../flux/stores/settings/MeasurementSettingStore";
import settingsActions from "../../flux/actions/SettingsAction";
import {
  defaultMeasurementSettingData,
  MeasurementSetting,
} from "../../models/settings/MeasurementSettings";
import thresholdSettingStore from "../../flux/stores/settings/ThresholdSettingStore";
import IThresholdSettings from "../../models/settings/ThresholdSettings";
import NoTrendToDisplay from "../shared/NoTrendToDisplay";
import utility from "../shared/Utility";
import directionActions from "../../flux/actions/DirectionAction";
import directionListStore from "../../flux/stores/direction/ListStore";
import Authorize from "../../utilities/Authorize";
import i18next from "i18next";
import Toast from "../../utilities/Toaster";

type PropsType = {
  activeItem: any;
  activeMeasurementId: any;
  settingsData: any;
  showToastMessage?: (e:boolean) => any;
};

interface ILandingState {
  sampleData: SampleViewData;
  measurementId: string;
  showSummary: boolean;
  sampleOverviewData: ISampleOverviewData;
  thresholdSettings: IThresholdSettings[];
  inputGradeName: string;
  inputProductName: string;
  showMore: boolean;
  showGradePopup: boolean;
  showProductPopup: boolean;
  inputCode: string;
  productNameError: boolean;
  gradeNameError: boolean;
  codeError: boolean;
  reportData: IReportPropertyData[];
  expandedRows: any[];
  expandedRowData: any[];
  buttonDisabled: boolean;
  isRowExpanded: boolean;
  series: any;
  selectedValueSingle: number[];
  chartType: ChartTypes;
  dateUnit: DateUnits;
  dateUnitCount: number;
  start?: Date;
  end?: Date;
  settings: MeasurementSetting;
  searchValue: string;
  selectedDirection: any;
  dropdownDirectionOptions: any;
  editMeasuredData: boolean;
  isMeasuredDataEditable: boolean;
  saveEditedMeasuredData: boolean;
  isCountValuesEdited: boolean;
  showEditedValuesLost: boolean;
  seriesData: any;
}

export default class MeasurementOverview extends React.Component<
  PropsType,
  ILandingState
> {
  start = new Date(2019, 0, 1, 0, 0, 0, 0);
  end = new Date(2019, 0, 5, 0, 0, 0, 0);

  private minXValue: number;
  private maxXValue: number;

  private _mount: boolean = false;
  private _sampleData: ISampleViewData = defaultSampleData;
  private _isMeasurementRejected: any;
  private _isMeasurementAproved: any;
  private _sampleOverviewData: ISampleOverviewData;
  private _isValid: boolean = false;
  private _message: string[];
  private _reportData: IReportPropertyData[];
  private _measuredPositionData: any[];
  private _calculatedPositionData: any[];
  private _keyedinPositionData: any[];
  private _settingsData: any;
  private _thresholdSettings: any;
  private _gradeCreatedId: string = "";
  private _All = "All";
  private _defaultDirection = [{ value: this._All, label: this._All }];
  private _directionsList: any[] = [];
  private duplicateExpandedRowData: string;
  private deepCloneExpandedRowData: any[] = [];
  private measuredPositionFromStore: any[] = [];
  private keyedinPositionFromStore: any[] = [];
  private propertyDetailsArray: IPropertyDetail[] = [];
  private _editMeasuredSample: any;
  private editMeasuredSampleReq: IEditSampleMeasurement;
  private wrapperRef: any;
  private saveWrapperRef: any;

  constructor(props: PropsType) {
    super(props);
    this._mount = true;

    this.wrapperRef = React.createRef();
    this.saveWrapperRef = React.createRef();
    this.minXValue = 0;
    this.maxXValue = 200;
    this.state = {
      searchValue: "",
      selectedDirection: [],
      dropdownDirectionOptions: this._defaultDirection,
      sampleData: this.props.activeItem || defaultSampleData,
      measurementId: this.props.activeItem?.measurementId || "",
      settings: defaultMeasurementSettingData,
      thresholdSettings: [],
      showSummary: false,
      sampleOverviewData: defaultSampleOverviewData,
      inputGradeName: "",
      inputProductName: "",
      showMore: false,
      showGradePopup: false,
      showProductPopup: false,
      inputCode: "",
      productNameError: false,
      gradeNameError: false,
      codeError: false,
      reportData: [],
      expandedRows: [],
      expandedRowData: [],
      buttonDisabled: true,
      isRowExpanded: false,
      selectedValueSingle: [0],
      chartType: "Bar",
      dateUnit: "Day",
      dateUnitCount: 4,
      start: this.start,
      end: this.end,
      editMeasuredData: true,
      isMeasuredDataEditable: false,
      saveEditedMeasuredData: false,
      isCountValuesEdited: false,
      showEditedValuesLost: false,
      series: [
        {
          name: "Position",
          color: "#5ABFAE",
          id: "1",
          markerStyle: {
            type: this.state?.chartType ==="Bar" ? "None" : "Circle",
          },
          yAxis: {
            min: this.minXValue,
            max: this.maxXValue,
            decimalPlaces: 2,
          },
          isShownInChart: true,
          points: this.generateOrdinalData1(0, 20, 1, 0, 100), // String
        },
      ],
      seriesData: {}
    };
  }

  // ====================================================================

  onDateRangeChange = (
    start: string | number | Date,
    end: string | number | Date,
    dateUnit: DateUnits,
    dateUnitCount: number,
    isOnZoom: boolean
  ) => {
    this.setState({
      dateUnit,
      dateUnitCount,
      start: start as Date,
      end: end as Date,
    });
  };

  onDataLimitVisibilityChange = (
    series: ISeries,
    limit: ITrendDataLimit,
    isShown: boolean
  ) => {
    let updatedValue = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        let limits = item.dataLimits.map((line: ITrendDataLimit) => {
          if (line.name === limit.name) {
            return { ...line, shownInChart: isShown };
          } else {
            return line;
          }
        });
        return { ...item, dataLimits: limits };
      } else {
        return item;
      }
    });

    this.setState({ series: updatedValue });
  };

  onChartTypeChange = (chartType: ChartTypes) => {
    this.setState({
      chartType: chartType,
    });
    return chartType;
  };

  onSeriesChartTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, chartType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesColorChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, color: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  getMarkerStyles = (value: string, item: ISeries) => {
    let marker = item.markerStyle ? { ...item.markerStyle } : {};
    if (value === "Circle") {
      marker.type = "Circle";
      marker.fillColor = "white";
    } else if (value === "Square") {
      marker.type = "Square";
      marker.fillColor = "white";
    } else if (value === "FillCircle") {
      marker.type = "Circle";
      marker.fillColor = "SeriesColor";
    } else if (value === "FillSquare") {
      marker.type = "Square";
      marker.fillColor = "SeriesColor";
    } else {
      marker.type = "None";
    }
    return marker;
  };

  onSeriesMarkerChange = (value: TrendMarkerTypes, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return {
          ...item,
          markerStyle: { ...series.markerStyle, type: value },
        } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onSeriesFillTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, fillType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  onInvalidPointTypeChange = (value: string, series: ISeries) => {
    let updatedValue: ISeries[] = this.state.series.map((item: any) => {
      if (item.name === series.name) {
        return { ...item, invalidPointLineType: value } as ISeries;
      } else {
        return item;
      }
    });
    this.setState({ series: updatedValue });
  };

  generateOrdinalData(
    fromDate: number,
    toDate: number,
    interval = 1,
    min: number,
    max: number,
    isNumber = false
  ) {
    const data = [];
    let i = 0;
    while (fromDate < toDate) {
      const obj = {
        xValue: isNumber ? fromDate : "Sample" + fromDate,
        value:
          parseInt((Math.random() * (max - min) + min).toString()) + 0.44444444,
        status: ["Valid", "Invalid", "Good"][i % 3],
        customValue: ["Reel", "Machine", "Paper"][i % 3],
      };
      data.push(obj);
      fromDate = fromDate + interval;
      i++;
    }
    return data;
  }

  generateOrdinalData1(
    fromDate: number,
    toDate: number,
    interval = 1,
    min: number,
    max: number,
    isNumber = false
  ) {
    const data = [
      {
        xValue: "sample1",
        value: 50,
      },
    ];
    return data;
  }

  generateOrdinalData2(rowData: any[], item: any) {

    const trendData: any[] = [];
    rowData.sort(utility.sortAlphaNum).map((row: any) => {
      trendData.push({
        xValue: row.positionName,
        value: row.positionMean != null ? row.positionMean : 0,
      });
    });
    if (trendData.length != 0) {
        trendData.push({ xValue: "", value: null });
    }
    const yValue: number[] = [
      item.alarmLow1,
      item.alarmLow2,
      item.alarmHigh1,
      item.alarmHigh2,
      item.rejectLow,
      item.rejectHigh,
    ];
    trendData.sort(utility.sortAlphaNum).forEach((item: any) => {
      yValue.push(item.value);
    });

    let minYValue: any = 0;
    let maxYValue: any = 0;

    if (Math.sign(_.min(yValue)) === -1) {
      minYValue = _.min(yValue) + (_.min(yValue) / 100) * 5;
      maxYValue = _.max(yValue) - (_.max(yValue) / 100) * 5;
    } else {
      // ITC Changes
      minYValue = _.min(yValue) - (_.min(yValue) / 100) * 5;
      // const minYValue: any = 0;
      maxYValue = _.max(yValue) + (_.max(yValue) / 100) * 5;
    }

    const series = [
      {
        name: "Position",
        color: "#5ABFAE",
        id: "1",
        markerStyle: {
          type: this.state?.chartType ==="Bar" ? "None" : "Circle",
        },
        yAxis: {
          min: minYValue,
          max: maxYValue,
          decimalPlaces: item?.decimals,
        },
        dataLimits: [
          {
            name: "Alarm Low Limit-1",
            shownInChart: true,
            showInToolTip: false,
            value: item?.alarmLow1,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
              ).colorCode,
            },
          },
          {
            name: "Alarm High Limit-1",
            shownInChart: true,
            showInToolTip: false,
            value: item?.alarmHigh1,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm High 1" || x.name === "Alarm Limit1"
              ).colorCode,
            },
          },
          {
            name: "Alarm Low Limit-2",
            shownInChart: true,
            showInToolTip: false,
            value: item?.alarmLow2,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
              ).colorCode,
            },
          },
          {
            name: "Alarm High Limit-2",
            shownInChart: true,
            showInToolTip: false,
            value: item?.alarmHigh2,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm High 2" || x.name === "Alarm Limit2"
              ).colorCode,
            },
          },
          {
            name: "Reject Low",
            shownInChart: true,
            showInToolTip: false,
            value: item?.rejectLow,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Reject Low" || x.name === "Reject Limit"
              ).colorCode,
            },
          },
          {
            name: "Reject High",
            shownInChart: true,
            showInToolTip: false,
            value: item?.rejectHigh,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Reject High" || x.name === "Reject Limit"
              ).colorCode,
            },
          },
        ],
        isShownInChart: true,
        points: trendData,
      },
    ];
    return series;
  }

  generateOrdinalData3(rowData: any, item: any) {

    const trendData: any[] = [];
    rowData.positionValues.map((row: any) => {
      if (row.count == 0) {
        trendData.push({
          xValue: "Calculated",
          value: row.value != null ? row.value : 0,
        });
      } else {
        trendData.push({
          xValue: row.count?.toString(),
          value: row.value != null ? row.value : 0,
        });
      }
    });

    if (trendData.length != 0) {
        trendData.push({ xValue: "", value: null });
    }

    const yValue: number[] = [
      item.alarmLow1,
      item.alarmLow2,
      item.alarmHigh1,
      item.alarmHigh2,
      item.rejectLow,
      item.rejectHigh,
    ];

    rowData.positionValues.sort(utility.sortAlphaNum).forEach((item: any) => {
      yValue.push(item.value);
    });
    let minYValue: any = 0;
    let maxYValue: any = 0;

    if (Math.sign(_.min(yValue)) === -1) {
      minYValue = _.min(yValue) + (_.min(yValue) / 100) * 5;
      maxYValue = _.max(yValue) - (_.max(yValue) / 100) * 5;
    } else {
      // ITC Changes
      minYValue = _.min(yValue) - (_.min(yValue) / 100) * 5;
      // const minYValue: any = 0;
      maxYValue = _.max(yValue) + (_.max(yValue) / 100) * 5;
    }

    const series = [
      {
        name: "Position",
        color: "#5ABFAE",
        id: "1",
        markerStyle: {
          type: this.state?.chartType ==="Bar" ? "None" : "Circle",
        },
        yAxis: {
          min: minYValue,
          max: maxYValue,
          decimalPlaces: item?.decimals,
        },
        dataLimits: [
          {
            name: "Alarm Low Limit-1",
            shownInChart: true,
            value: item?.alarmLow1,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm Low 1" || x.name === "Alarm Limit1"
              ).colorCode,
            },
          },
          {
            name: "Alarm High Limit-1",
            shownInChart: true,
            value: item?.alarmHigh1,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm High 1" || x.name === "Alarm Limit1"
              ).colorCode,
            },
          },
          {
            name: "Alarm Low Limit-2",
            shownInChart: true,
            value: item?.alarmLow2,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm Low 2" || x.name === "Alarm Limit2"
              ).colorCode,
            },
          },
          {
            name: "Alarm High Limit-2",
            shownInChart: true,
            value: item?.alarmHigh2,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Alarm High 2" || x.name === "Alarm Limit2"
              ).colorCode,
            },
          },
          {
            name: "Reject Low",
            shownInChart: true,
            value: item?.rejectLow,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Reject Low" || x.name === "Reject Limit"
              ).colorCode,
            },
          },
          {
            name: "Reject High",
            shownInChart: true,
            value: item?.rejectHigh,
            className: "custom-line-graph",
            style: {
              stroke: this.state.thresholdSettings.find(
                (x) => x.name === "Reject High" || x.name === "Reject Limit"
              ).colorCode,
            },
          },
        ],
        isShownInChart: true,
        points: trendData,
      },
    ];
    return series;
  }

  generateData(
    fromDate: Date,
    toDate: Date,
    interval = 180000,
    min: number,
    max: number
  ) {
    const data = [];
    let i = 0;
    while (fromDate.getTime() < toDate.getTime()) {
      const obj = {
        xValue: new Date(fromDate),
        value:
          parseInt((Math.random() * (max - min) + min).toString()) + 0.44444444,
        status: ["Valid", "Invalid", "Good"][i % 3],
        customValue: ["Reel", "Machine", "Paper"][i % 3],
      };
      data.push(obj);
      fromDate = new Date(fromDate.getTime() + interval);
      i++;
    }
    return data;
  }

  // ====================================================================

  componentWillUnmount() {
    this._mount = false;
  }

  private getGeneralSettings = () => {
    this._settingsData = this.props.settingsData;
    this.setState({
      settings: this._settingsData,
      chartType: this._settingsData?.selectedGraphType?.name,
    });
  };
  private getDirectionData = () => {
    directionActions.getAll().then(() => {
      const Datalist: any[] = [];
      let Filteredlist: any[] = [];
      this.state.reportData.forEach((el: any) => {
        if (!Datalist.includes(el.directionId)) {
          Datalist.push(el.directionId);
        }
      });
      if (this._directionsList && Datalist && Datalist.length) {
        Datalist.forEach((el) => {
          const listData = this._directionsList.find((ele) => ele.value === el);
          if (listData) Filteredlist.push(listData);
        });

        if (Filteredlist && Filteredlist.length) {
          Filteredlist = _.sortBy(Filteredlist, "label");
        }
      }
      this.setState({
        dropdownDirectionOptions: [...this._defaultDirection, ...Filteredlist],
      });
    });
  };

  componentDidMount() {
    this._mount = true;
    MeasurementRejectStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementRejected = state.isMeasurementRejected;
      }
    });

    MeasurementApproveStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementAproved = state.isMeasurementApproved;
      }
    });

    SampleOverviewStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._sampleOverviewData = state.data;
      }
    });

    gradeFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._gradeCreatedId = state.gradeId;
        this._message = state.message;
      }
    });

    productFormStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._message = state.message;
      }
    });

    sampleReportStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._reportData = state.reportData.properties;
      }
    });

    measuredPositionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._measuredPositionData = state.data.data.propertyPositionValues;
        this.measuredPositionFromStore = JSON.parse(
          JSON.stringify(state.data.data.propertyPositionValues)
        );
      }
    });

    calculatedPositionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._calculatedPositionData = state.data.data.calculatedPositionValue;
      }
    });
    keyedInPositionStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._keyedinPositionData = state.data.data.propertyPositionValues;
        this.keyedinPositionFromStore = JSON.parse(
          JSON.stringify(state.data.data.propertyPositionValues)
        );
      }
    });
    sampleMeasurementEditStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._editMeasuredSample = state.data.data;
      }
    });

    thresholdSettingStore.on(CONSTANTS.CHANGE_EVENT, (state: any) => {
      if (this._mount) {
        this._thresholdSettings = state.data;
      }
    });

    this.getGeneralSettings();
    this.getThresholdValues();
    this.measurementOverview();

    // directions list
    directionListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        state.directionDataList.forEach((data: any) => {
          const direction = {
            label: data.name,
            value: data.id,
          };
          this._directionsList.push(direction);
        });
      }
    });
  }

  private getThresholdValues = () => {
    settingsActions
      .getThresholdReport()
      .then(() => {
        this.setState({
          thresholdSettings: this._thresholdSettings,
        });
      })
      .catch((e) => {
        triggerNotifications.error(e);
      });
  };

  componentDidUpdate(prevProps: any) {
    if (prevProps.activeItem.id !== this.props.activeItem.id) {
      if (this.props.activeItem !== undefined) {
        this.setState(
          {
            sampleData: this.props.activeItem,
            selectedDirection: [],
            searchValue: "",
            expandedRows: [],
            expandedRowData: [],
            series: [
              {
                name: "Position",
                color: "#5ABFAE",
                id: "1",
                markerStyle: {
                  type: this.state?.chartType ==="Bar" ? "None" : "Circle",
                },
                yAxis: {
                  min: this.minXValue,
                  max: this.maxXValue,
                  decimalPlaces: 2,
                },
                isShownInChart: true,
                points: this.generateOrdinalData1(0, 20, 1, 0, 100), // String
              },
            ],
          },
          () => {
            this.measurementOverview();
            this.getGeneralSettings();
          }
        );
      }
    }
  }

  public onShowSummary = () => {
    this.setState({
      showSummary: !this.state.showSummary,
    });
  };

  private measurementOverview = () => {
    measurementActions
      .getMeasurementOverviewDetail(this.state.sampleData.id)
      .then(() => {
        this.setState(
          {
            sampleOverviewData: this._sampleOverviewData,
            measurementId: this._sampleOverviewData.measurementId,
          },
          () => {
            sampleActions
              .getReport(
                this.state.sampleData.id,
                this.state.measurementId,
                this.state.sampleData?.product?.id
              )
              .then(() => {
                this.setState({ reportData: this._reportData }, () => {
                  this.getDirectionData();
                });
              })
              .catch((error) =>
                triggerNotifications.errors(error.message, error.data).then()
              );
          }
        );
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private measurementApprove = () => {
    measurementActions
      .approveSampleMeasurement(
        this.state.sampleData.id,
        this.state.measurementId,
        uuidv4()
      )
      .then(() => {
        if (this._isMeasurementAproved) {
          triggerNotifications.success([CONSTANTS.SAMPLE_APPROVED_MESSAGE]);
          setTimeout(() => {
            History.push({
              pathname: CONSTANTS.SAMPLE_INDEX_URL,
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        }
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private measurementReject = () => {
    measurementActions
      .rejectSampleMeasurement(
        this.state.sampleData.id,
        this.state.measurementId,
        uuidv4()
      )
      .then(() => {
        if (this._isMeasurementRejected) {
          triggerNotifications.success([CONSTANTS.SAMPLE_REJECTED_MESSAGE]);
          setTimeout(() => {
            History.push({
              pathname: CONSTANTS.SAMPLE_INDEX_URL,
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        }
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  public setGradeName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    if (val.trim() && /^[a-zA-Z0-9 ]*$/g.test(val)) {
      this.setState(
        { gradeNameError: false, inputGradeName: val },
        this.validate
      );
    } else {
      this.setState(
        { gradeNameError: true, inputGradeName: val },
        this.validate
      );
    }
  };

  public setProductName = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    if (val.trim() && /^[a-zA-Z0-9 ]*$/g.test(val)) {
      this.setState(
        { productNameError: false, inputProductName: val },
        this.validate
      );
    } else {
      this.setState(
        { productNameError: true, inputProductName: val },
        this.validate
      );
    }
  };

  public setCode = (value: string) => {
    const val = value.length > 1 ? value : value.replace(/\s/g, "");
    if (val.trim() && /^[a-zA-Z0-9 ]*$/g.test(val)) {
      this.setState({ codeError: false, inputCode: val }, this.validate);
    } else {
      this.setState({ codeError: true, inputCode: val }, this.validate);
    }
  };

  public onGradeActivate = () => {
    this.setState({
      showGradePopup: true,
      showProductPopup: false,
      showMore: false,
    });
  };

  public onProductActivate = () => {
    this.setState({
      showProductPopup: true,
      showGradePopup: false,
      showMore: false,
    });
  };
  public onMoreClick = () => {
    this.setState({
      showMore: !this.state.showMore,
    });
  };

  public onCloseGrade = () => {
    this.setState({
      showGradePopup: false,
      gradeNameError: false,
      productNameError: false,
      codeError: false,
      inputGradeName: "",
      inputCode: "",
    });
  };
  public onCloseProduct = () => {
    this.setState({
      showProductPopup: false,
      gradeNameError: false,
      productNameError: false,
      codeError: false,
      inputProductName: "",
      inputCode: "",
    });
  };

  public onCreateProduct = (e: any, val: boolean) => {
    this.setState({
      showProductPopup: false,
    });
    const sampleId = this.state.sampleData.id;
    const productName = this.state.inputProductName;
    const codeId = this.state.inputCode;
    if (this._isValid) {
      const productBody = new SampleGradeProductFormData(
        uuidv4(),
        sampleId,
        productName,
        codeId
      );
      productActions
        .createProductSample(
          productBody,
          "00000000-0000-0000-0000-000000000000"
        )
        .then(() => {
          triggerNotifications.success(this._message).then();
          this.setState({
            inputProductName: "",
            inputCode: "",
            gradeNameError: false,
            productNameError: false,
            codeError: false,
            buttonDisabled: true,
          });
        })
        .catch((error) => {
          this.setState(
            {
              inputProductName: "",
              inputCode: "",
              gradeNameError: false,
              productNameError: false,
              codeError: false,
              buttonDisabled: true,
            },
            () => triggerNotifications.errors(error.message, error.data).then()
          );
        });
    } else {
      this.setState(
        {
          inputProductName: "",
          inputCode: "",
          gradeNameError: false,
          productNameError: false,
          codeError: false,
        },
        () => triggerNotifications.error(CONSTANTS.NAME_OR_CODEID_REQUIRED)
      );
    }
  };

  public onCreateGrade = (e: any, val: boolean) => {
    this.setState({
      showGradePopup: false,
    });
    const sampleId = this.state.sampleData.id;
    const gradeName = this.state.inputGradeName;
    const codeId = this.state.inputCode;
    if (this._isValid) {
      const gradeBody = new SampleGradeProductFormData(
        uuidv4(),
        sampleId,
        gradeName,
        codeId
      );
      gradeActions
        .createGradeSample(gradeBody)
        .then(() => {
          const productBody = new SampleGradeProductFormData(
            uuidv4(),
            sampleId,
            gradeName,
            codeId
          );
          productActions
            .createProductSample(productBody, this._gradeCreatedId)
            .then(() => {
              triggerNotifications
                .success([i18next.t("Grade and Product created")])
                .then();
              this.setState({
                inputGradeName: "",
                inputCode: "",
                gradeNameError: false,
                productNameError: false,
                codeError: false,
                buttonDisabled: true,
              });
            });
        })
        .catch((error) => {
          this.setState(
            {
              inputGradeName: "",
              inputCode: "",
              gradeNameError: false,
              productNameError: false,
              codeError: false,
              buttonDisabled: true,
            },
            () => triggerNotifications.errors(error.message, error.data).then()
          );
        });
    } else {
      this.setState(
        {
          inputGradeName: "",
          inputProductName: "",
          inputCode: "",
          gradeNameError: false,
          productNameError: false,
          codeError: false,
        },
        () => triggerNotifications.error(CONSTANTS.NAME_OR_CODEID_REQUIRED)
      );
    }
  };

  validate(): void {
    if (
      !this.state.codeError &&
      this.state.inputCode.trim() &&
      this.state.inputCode !== "" &&
      ((!this.state.gradeNameError &&
        this.state.inputGradeName.trim() &&
        this.state.inputGradeName !== "") ||
        (!this.state.productNameError &&
          this.state.inputProductName.trim() &&
          this.state.inputProductName !== ""))
    ) {
      this._isValid = true;
      this.setState({
        buttonDisabled: false,
      });
    } else {
      this._isValid = false;
      this.setState({
        buttonDisabled: true,
      });
    }
  }

  handleRowClick(rowId: IReportPropertyData) {
    const newExpandedRowId = `${rowId.id}-${rowId.instrumentId}-${rowId.directionId}`
    if (this.state.expandedRows.includes(newExpandedRowId)) {
      const removedData = this.state.expandedRows.filter((el) => {
        return !el.includes(newExpandedRowId);
      });
      const removedRowData = this.state.expandedRowData.filter((el) => {
        return !el.id.includes(newExpandedRowId);
      });
      const removedSeriesData = this.state.series.filter((el: any) => {
        return !el.id.includes(newExpandedRowId);
      });
      this.setState({
        expandedRows: removedData,
        expandedRowData: removedRowData,
        series: removedSeriesData,
      });
    } else {
      const currentExpandedRows: any[] = this.state.expandedRows;
      const newExpandedRows = currentExpandedRows.concat(newExpandedRowId);
      this.setState({ expandedRows: newExpandedRows }, () => {
        if (rowId.propertyType === PropertyType.MEASURED) {
          this.measuredPosition(
            rowId.instrumentId,
            rowId.id,
            rowId.directionId,
            rowId.name
          );
        } else if (rowId.propertyType === PropertyType.KEYEDIN) {
          this.keyedInPosition(
            rowId.instrumentId,
            rowId.id,
            rowId.directionId,
            rowId.name);
        } else {
          this.calculatedPosition(
            rowId.instrumentId,
            rowId.id,
            rowId.directionId,
            rowId.name
          );
        }
      });
    }
  }

  changeSelectedHandler = (item: any, series: any) => {
    const thresholdSettings: any[] = [];
    const seriesData = JSON.parse(JSON.stringify(series));
    this.state.thresholdSettings.map((element, index) => {
      if (index === item) {
        element.isActive = !element.isActive;
        seriesData[0]?.dataLimits?.forEach((el: any) => {
          if (item == 0) {
            if (
              el.name === "Alarm Low Limit-1" ||
              el.name === "Alarm High Limit-1"
            ) {
              if (element.isActive) {
                el.shownInChart = true;
              } else {
                el.shownInChart = false;
              }
            }
          }
          if (item == 1) {
            if (
              el.name === "Alarm Low Limit-2" ||
              el.name === "Alarm High Limit-2"
            ) {
              if (element.isActive) {
                el.shownInChart = true;
              } else {
                el.shownInChart = false;
              }
            }
          }
          if (item == 4) {
            if (el.name === "Reject Low" || el.name === "Reject High") {
              if (element.isActive) {
                el.shownInChart = true;
              } else {
                el.shownInChart = false;
              }
            }
          }
        });
        thresholdSettings.push(element);
      } else {
        thresholdSettings.push(element);
      }
    });

    this.setState(
      {
        thresholdSettings: thresholdSettings,
        series: seriesData,
      },
      () => {
        console.log(this.state?.series);
      }
    );
  };

  preventRowClickOnEditMode = () => {
    this.setState({ showEditedValuesLost: true }, () => {
      document.body.removeEventListener("mousedown", this.handleClickOutside);
    });
  };

  renderItem(data: any, index: any) {
    const clickCallback = () => this.handleRowClick(data);
    const newExpandedRowId = `${data.id}-${data.instrumentId}-${data.directionId}`
    const itemRows = [
      <tr
        key={"row-data-" + newExpandedRowId}
        onClick={
          this.state.isMeasuredDataEditable &&
          this.state.expandedRows.includes(newExpandedRowId)
            ? this.preventRowClickOnEditMode
            : clickCallback
        }
        style={
          this.state.expandedRows.includes(newExpandedRowId)
            ? { background: "#DBDBDB" }
            : {}
        }
        className="cursor-pointer"
      >
        <td className="normal-row">
          <Icon
            name={
              this.state.expandedRows.includes(newExpandedRowId)
                ? ABB_CARET_DOWN
                : ABB_CARET_RIGHT
            }
            sizeClass="medium"
            color="black"
          />
        </td>
        <td className="normal-row sample_summary_name">
          <WithTooltip>
            <span className="text-ellipsis width-8rem">
              {data.name.replace("--", "")}
            </span>
            <Tooltip className="nav-tooltip">
              <p>{data.name.replace("--", "")}​​​​​</p>
            </Tooltip>
          </WithTooltip>
        </td>
        <td className="normal-row">{data.unit}</td>
        <td className="normal-row">
          <WithTooltip>
            <span className="text-ellipsis width-5rem">
              {data != null && data.mean != null && !isNaN(data.mean)
                ? data.mean.toFixed(data.decimals)
                : CONSTANTS.NOTCONSIDEREDFORCALC}
            </span>
            <Tooltip className="px-2 nav-tooltip">
              <p>
                {data != null && data.mean != null && !isNaN(data.mean)
                  ? data.mean.toFixed(data.decimals)
                  : CONSTANTS.NOTCONSIDEREDFORCALC}
              </p>
            </Tooltip>
          </WithTooltip>
        </td>
        <td className="normal-row">
          <WithTooltip>
            <span className="text-ellipsis width-5rem">
              {data != null &&
                data.standardDeviation != null &&
                !isNaN(data.standardDeviation)
                ? data.standardDeviation.toFixed(data.decimals)
                : CONSTANTS.NOTCONSIDEREDFORCALC}
            </span>
            <Tooltip className="px-2 nav-tooltip">
              <p>
                {data != null &&
                  data.standardDeviation != null &&
                  !isNaN(data.standardDeviation)
                  ? data.standardDeviation.toFixed(data.decimals)
                  : CONSTANTS.NOTCONSIDEREDFORCALC}
              </p>
            </Tooltip>
          </WithTooltip>
        </td>
        <td className="normal-row">
          <WithTooltip>
            <span className="text-ellipsis width-5rem">
              {data != null && data.min != null && !isNaN(data.min)
                ? Number(data.min).toFixed(data.decimals)
                : CONSTANTS.NOTCONSIDEREDFORCALC}
            </span>
            <Tooltip className="px-2 nav-tooltip">
              <p>
                {data != null && data.min != null && !isNaN(data.min)
                  ? Number(data.min).toFixed(data.decimals)
                  : CONSTANTS.NOTCONSIDEREDFORCALC}
              </p>
            </Tooltip>
          </WithTooltip>
        </td>
        <td className="normal-row">
          <WithTooltip>
            <span className="text-ellipsis width-5rem">
              {data != null && data.max != null && !isNaN(data.max)
                ? Number(data.max).toFixed(data.decimals)
                : CONSTANTS.NOTCONSIDEREDFORCALC}
            </span>
            <Tooltip className="px-2 nav-tooltip">
              <p>
                {data != null && data.max != null && !isNaN(data.max)
                  ? Number(data.max).toFixed(data.decimals)
                  : CONSTANTS.NOTCONSIDEREDFORCALC}
              </p>
            </Tooltip>
          </WithTooltip>
        </td>
        <td className="normal-row">{data.ok}</td>
        <td className="normal-row">{data.alarm1}</td>
        <td className="normal-row">{data.alarm2}</td>
        <td className="normal-row">{data.reject}</td>
      </tr>,
    ];
    if (this.state.expandedRows.includes(newExpandedRowId)) {
      const indexId = `${data.id}-${data.instrumentId}-${data.directionId}`
      let max = -Infinity;
      let iterableData: any[] = [];
      let countData: any[] = [];
      let seriesData: any[] = [];
      const filterexpandedRow = this.state.expandedRowData.filter((el) => {
        return el.id === indexId;
      });

      if (filterexpandedRow && filterexpandedRow.length) {
        filterexpandedRow[0].data.forEach((element: any) => {
          if (element.id === indexId) {
            countData.push(element);
            iterableData.push(element.positionValues);
          }
        });
      }

      const filterexpandedSeries = this.state.series.filter((el: any) => {
        return el.id === indexId;
      });
      if (
        filterexpandedSeries &&
        filterexpandedSeries.length &&
        filterexpandedSeries[0].data
      ) {
        seriesData = filterexpandedSeries[0].data;
      }
      const maxIterable = iterableData.map((a) => a.length);
      maxIterable.indexOf(Math.max(...maxIterable));
      max = Math.max(...maxIterable);
      const b = _.maxBy(countData, "positionCounts.totalCounts");
      itemRows.push(
        <tr>
          <td colSpan={11}>
            <div
              key={index}
              className="p-4"
              style={{
                background: "#DBDBDB",
                marginTop: "-4px",
              }}
            >
              <React.Fragment>
                <div className="fr" style={{ marginRight: "2rem" }}>
                  {this.state?.thresholdSettings?.map((th: any, i: number) => {
                    return th.key === "RJLT" ||
                      th.key === "ALLT2" ||
                      th.key === "ALLT1" ? (
                      <div
                        className={
                          th?.isActive
                            ? "fl threshold" //fullopacity
                            : "fl threshold"// halfopacity
                        }
                        key={i}
                      >
                        <div
                          className="fl threshold-box"
                          style={{ background: th?.colorCode }}
                        />
                        <span className="fl threshold-text">{i18next.t(th?.name)} </span>
                      </div>
                    ) : (
                      ""
                    );
                  })}
                </div>
                <div className="clearfix" />
              </React.Fragment>

              <div className="abb-wrapper">
                <div className="abb-scroller">
                  <form>
                    <table className="abb-count-table w-100">
                      {this.state.selectedValueSingle[0] === 0 ? (
                        <React.Fragment>
                          <thead>
                            <tr>
                              <th className="row-data align-center">{i18next.t("Position")}</th>
                              <th className="row-data align-center">{i18next.t("Counts")}</th>
                              <th className="row-data align-center">{i18next.t("Pos. Avg")}</th>
                              {}
                              {this.iterablesHeader(b)}
                            </tr>
                          </thead>
                          <tbody>
                            {filterexpandedRow &&
                            filterexpandedRow.length &&
                            filterexpandedRow[0].data ? (
                              filterexpandedRow[0].data.map(
                                (dt: any, index: any) => {
                                  if (dt.id === indexId) {
                                    return (
                                      <tr key={`row-expanded-${index}${dt.id}`}>
                                        <td className="normal-row align-center">
                                          {dt !== undefined && dt.positionName}
                                        </td>
                                        <td className="normal-row align-center">
                                          {dt !== undefined &&
                                            dt.propertyType === undefined &&
                                            dt.positionCounts.completedCounts +
                                              " /" +
                                              dt.positionCounts.totalCounts}
                                        </td>
                                        <td className="normal-row align-center">
                                          <WithTooltip>
                                            <div className="text-ellipsis width-5rem">
                                              {dt !== undefined &&
                                              dt.positionMean != null &&
                                              !isNaN(dt.positionMean)
                                                ? dt.positionMean.toFixed(
                                                    data.decimals
                                                  )
                                                : CONSTANTS.NOTCONSIDEREDFORCALC}
                                            </div>
                                            <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                                              <p>
                                                {dt !== undefined &&
                                                dt.positionMean != null &&
                                                !isNaN(dt.positionMean)
                                                  ? dt.positionMean.toFixed(
                                                      data.decimals
                                                    )
                                                  : CONSTANTS.NOTCONSIDEREDFORCALC}
                                              </p>
                                            </Tooltip>
                                          </WithTooltip>
                                        </td>
                                        {this.iterables(
                                          dt,
                                          index,
                                          maxIterable,
                                          max,
                                          b,
                                          data
                                        )}
                                      </tr>
                                    );
                                  }
                                }
                              )
                            ) : (
                              <></>
                            )}
                          </tbody>
                        </React.Fragment>
                      ) : (
                        <tbody>
                          <tr>
                            <td colSpan={7}>
                              {seriesData && seriesData.length > 0 ? (
                                <Trend
                                  chartType={
                                    this.state.settings?.selectedGraphType?.name
                                  }
                                  invalidPointLineType="None"
                                  invalidStatuses={["Invalid"]}
                                  dateUnit={this.state.dateUnit}
                                  dateUnitCount={this.state.dateUnitCount}
                                  gridLineColor="grey"
                                  gridLineWidth={0.5}
                                  showVerticalGridLines={false}
                                  showHorizontalGridLines={true}
                                  series={seriesData}
                                  xAxis={{
                                    type: "Ordinal",
                                    tickAngle: 45,
                                    height: 60,
                                  }}
                                  onChartTypeChange={this.onChartTypeChange}
                                  onDataLimitVisibilityChange={
                                    this.onDataLimitVisibilityChange
                                  }
                                  onDateRangeChange={this.onDateRangeChange}
                                  onInvalidPointTypeChange={
                                    this.onInvalidPointTypeChange
                                  }
                                  onSeriesChartTypeChange={
                                    this.onSeriesChartTypeChange
                                  }
                                  onSeriesColorChange={this.onSeriesColorChange}
                                  onSeriesFillTypeChange={
                                    this.onSeriesFillTypeChange
                                  }
                                  onSeriesMarkerChange={
                                    this.onSeriesMarkerChange
                                  }
                                  trendChartHeight={300}
                                  showChartType={false}
                                  showDateTimePicker={false}
                                  showOuterBorder={false}
                                  showTableData={false}
                                  yAxisTicksCount={5}
                                  yAxisWidth={75}
                                  tooltipPosition="Middle"
                                />
                              ) : (
                                <div>
                                  <NoTrendToDisplay></NoTrendToDisplay>
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </form>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    }
    return itemRows;
  }

  private iterablesHeader(b: any) {
    let arr: any[] = [];
    if (b !== undefined) {
      for (let i = 0; i < b.positionCounts.totalCounts; i++) {
        arr.push(
          <th className="row-data align-center" key={i}>
            {i + 1}
          </th>
        );
      }
    }
    return arr;
  }

  private iterables(
    data: any,
    index: number,
    maxIterable: any[],
    max: number,
    b: any,
    mainData: any
  ) {
    let count =
      data && data.positionCounts ? data?.positionCounts?.totalCounts : max;
    let arr: any[] = [];
    if (max !== undefined) {
      for (let i = 0; i < count; i++) {
        let val;
        let value;
        let countValue: any;
        let valueRangeStatusId: any;
        let valueRangeStatus: any;
        if (mainData.propertyType === PropertyType.KEYEDIN) {
          val = data.positionValues.find((x: any) => x.count === i + 1);
          value =
            val !== undefined && val.value != null && !isNaN(val.value)
              ? val.value
              : CONSTANTS.NOTCONSIDEREDFORCALC;
          countValue = val !== undefined ? val.count : i + 1;
          valueRangeStatusId = val !== undefined ? val.valueRangeStatusId : "";
          valueRangeStatus = val !== undefined ? val.valueRangeStatus : "";
        } else if (mainData.propertyType === PropertyType.MEASURED) {
          val = data?.positionValues?.find((x: any) => x.count === i + 1);

          value =
            val !== undefined && val.value != null && !isNaN(val.value)
              ? val.value
              : CONSTANTS.NOTCONSIDEREDFORCALC;

          countValue = val !== undefined ? val.count : i + 1;
          valueRangeStatusId = val !== undefined ? val.valueRangeStatusId : "";
          valueRangeStatus = val !== undefined ? val.valueRangeStatus : "";
        } else {
          val = data?.positionValues[i];
          value =
            val !== undefined && val.value != null && !isNaN(val.value)
              ? val.value
              : CONSTANTS.NOTCONSIDEREDFORCALC;
        }
        value =
          typeof value !== "number" &&
          !this.state.isMeasuredDataEditable &&
          value !== CONSTANTS.NOTCONSIDEREDFORCALC
            ? parseFloat(value)
            : value;
        value =
          this.state.isMeasuredDataEditable &&
          value === CONSTANTS.NOTCONSIDEREDFORCALC
            ? ""
            : value;
        let color = "#262626";
        if (val !== undefined) {
          if (val.valueRangeStatus === "Alarm Limit1") {
            color = this.state.thresholdSettings.find(
              (x) => x.name === "Alarm Limit1"
            ).colorCode;
          } else if (val.valueRangeStatus === "Alarm Limit2") {
            color = this.state.thresholdSettings.find(
              (x) => x.name === "Alarm Limit2"
            ).colorCode;
          } else if (val.valueRangeStatus === "Reject Limit") {
            color = this.state.thresholdSettings.find(
              (x) => x.name === "Reject Limit"
            ).colorCode;
          } else if (val.valueRangeStatus === "Within Limit") {
            color = CONSTANTS.WITHIN_LIMIT_BG_COLOR;
          }
        }
        let keyValue = `input${index + 1}${data.id}-${
          data.position
        }-${countValue}`;
        let labelValue;
        if (mainData.propertyType === PropertyType.CALCULATED) {
          labelValue =
            value !== "" &&
            value !== CONSTANTS.NOTCONSIDEREDFORCALC &&
            !isNaN(value)
              ? value.toFixed(mainData.decimals)
              : CONSTANTS.NOTCONSIDEREDFORCALC;
        } else {
          labelValue =
            value !== "" &&
            value !== CONSTANTS.NOTCONSIDEREDFORCALC &&
            !isNaN(value) &&
            !this.state.isMeasuredDataEditable
              ? value.toFixed(mainData.decimals)
              : CONSTANTS.NOTCONSIDEREDFORCALC;
        }
        
        arr.push(
          <td className="normal-row align-center" key={keyValue}>
            {this.state.isMeasuredDataEditable &&
            mainData.propertyType !== "Calculated" ? (
              <input
                type="text"
                key={keyValue}
                name={keyValue}
                id={keyValue}
                value={value}
                style={{ color: "black" }}
                onChange={(e: any) =>
                  this.handleInputValueChange(
                    e,
                    data.id,
                    data.position,
                    countValue
                  )
                }
                onKeyDown={(e: any) => this.changeFocus(e)}
                onBlur={(e: any) =>
                  this.emptyValueCheck(
                    e,
                    { countValue, valueRangeStatusId, valueRangeStatus },
                    data,
                    mainData
                  )
                }
              />
            ) : (
              <WithTooltip>
                <div className="text-ellipsis width-5rem alarm-color-padding" style={{ background: labelValue !== "(--)" ? color : "transparent" }}>
                <span style={{ color: labelValue !== "(--)" ? utility.pickTextColorBasedOnBgColorAdvanced(color, '#FFFFFF', '#000000') : color }}>{labelValue}</span>
                </div>
                <Tooltip className="pl-2 pr-2 pb-1 nav-tooltip">
                  <p>{labelValue}​​​​​</p>
                </Tooltip>
              </WithTooltip>
            )}
          </td>
        );
      }
    }
    return arr;
  }

  private handleInputValueChange = (
    e: any,
    id: any,
    position: string,
    count: any
  ) => {
    e.persist();
    const bool = /^-?\d*?\.?\d*$/g.test(e.target.value);
    if (!bool) {
      return;
    }
    const updateSkippedCount = {
      count: count,
      value: e.target.value,
      valueRangeStatus: "",
      valueRangeStatusId: "",
    };
    const duplicateArray: any = [...this.state.expandedRowData];
    const currentArray = duplicateArray.filter((item: any) => item.id === id);
    const currentArrayIndex = duplicateArray.findIndex(
      (item: any) => item.id === id
    );
    const currentDataFromArray = currentArray[0].data.find(
      (x: any) =>
        x.id === id &&
        x.position === position
    );
    const currentDataFromArrayIndex = currentArray[0].data.findIndex(
      (x: any) =>
        x.id === id &&
        x.position === position
    );
    const updatedValue = currentDataFromArray.positionValues.find(
      (x: any) =>
        x.count === count
    );
    const updatedValueIndex = currentDataFromArray.positionValues.findIndex(
      (x: any) =>
        x.count === count
    );
    if (updatedValue === undefined || updatedValueIndex === -1) {
      duplicateArray[currentArrayIndex].data[
        currentDataFromArrayIndex
      ].positionValues.push(updateSkippedCount);
    } else {
      updatedValue.value = e.target.value;
      duplicateArray[currentArrayIndex].data[
        currentDataFromArrayIndex
      ].positionValues[updatedValueIndex] = updatedValue;
    }
    this.setState({
      expandedRowData: duplicateArray,
      isCountValuesEdited: true,
    });
  };

  private changeFocus = (e: any) => {
    if (e.key.toLowerCase() === "enter") {
      const form = e.target.form;
      const index = [...form].indexOf(e.target);
      if (index === form.length - 1) {
        form.elements[index].blur();
      } else {
        form.elements[index + 1].focus();
      }
      e.preventDefault();
    }
  };

  private measuredPosition = (
    instrumentId: string,
    propertyId: string,
    directionId: string,
    propertyName: string
  ) => {
    // measuredPositionStore
    sampleActions
      .getMeasuredPropertyPosition(
        this.state.measurementId,
        instrumentId,
        propertyId,
        directionId
      )
      .then(() => {
        const indexId = propertyId + "-" + instrumentId + "-" + directionId;
        let rowData: any[] = [];
        let duplicateRowData: any[] = [];
        this._measuredPositionData.map((data, index) => {
          const pushData = { ...data, id: indexId };
          rowData.push(pushData);
        });

        this.measuredPositionFromStore.map((data, index) => {
          const duplicatePushData = { ...data, id: indexId };
          duplicateRowData.push(duplicatePushData);
        });

        let item = this.state.reportData.find((items) => {
          return items.name === propertyName;
        });
        const trendData = this.generateOrdinalData2(rowData, item);
        const expandedRowData = [...this.state.expandedRowData];
        expandedRowData.push({
          id: indexId,
          data: rowData,
        });
        if (this.deepCloneExpandedRowData.length !== 0) {
          const tempArray = this.deepCloneExpandedRowData.filter(
            (x: any) => x.id === indexId
          );
          if (tempArray.length === 0) {
            this.deepCloneExpandedRowData.push({
              id: indexId,
              data: duplicateRowData,
            });
          } else {
            const tempObj = {
              id: indexId,
              data: duplicateRowData,
            };
            const index = this.deepCloneExpandedRowData.indexOf(tempArray[0]);
            this.deepCloneExpandedRowData.splice(index, 1, tempObj);
          }
        } else {
          this.deepCloneExpandedRowData.push({
            id: indexId,
            data: duplicateRowData,
          });
        }
        this.duplicateExpandedRowData = JSON.stringify(
          this.deepCloneExpandedRowData
        );
        const series = [...this.state.series];
        const seriesIndex = series.findIndex((e) => e.id === indexId);
        if (seriesIndex === -1) {
          series.push({
            id: indexId,
            data: trendData,
          });
        } else {
          const seriesObj = {
            id: indexId,
            data: trendData,
          }
          series[seriesIndex] = seriesObj;
        }
        this.setState({
          expandedRowData,
          series,
        });
      })
      .catch((error) =>
        triggerNotifications.errors(error.message, error.data).then()
      );
  };
  private keyedInPosition = (
    instrumentId: string,
    propertyId: string,
    directionId: string,
    propertyName: string
  ) => {
    // measuredPositionStore
    sampleActions
      .getKeyedInPropertyPosition(
        this.state.measurementId,
        propertyId,
        directionId
      )
      .then(() => {
        const indexId = propertyId + "-" + instrumentId + "-" + directionId;
        let rowData: any[] = [];
        let duplicateRowData: any[] = [];
        this._keyedinPositionData.map((data, index) => {
          const pushData = { ...data, id: indexId };
          rowData.push(pushData);
        });
        this.keyedinPositionFromStore.map((data, index) => {
          const duplicatePushData = { ...data, id: indexId };
          duplicateRowData.push(duplicatePushData);
        });
        let item = this.state.reportData.find((items) => {
          return items.name === propertyName;
        });
        const trendData = this.generateOrdinalData2(rowData, item);

        const expandedRowData = [...this.state.expandedRowData];
        expandedRowData.push({
          id: indexId,
          data: rowData,
        });
        if (this.deepCloneExpandedRowData.length !== 0) {
          const tempArray = this.deepCloneExpandedRowData.filter(
            (x: any) => x.id === indexId
          );
          if (tempArray.length === 0) {
            this.deepCloneExpandedRowData.push({
              id: indexId,
              data: duplicateRowData,
            });
          } else {
            const tempObj = {
              id: indexId,
              data: duplicateRowData,
            };
            const index = this.deepCloneExpandedRowData.indexOf(tempArray[0]);
            this.deepCloneExpandedRowData.splice(index, 1, tempObj);
          }
        } else {
          this.deepCloneExpandedRowData.push({
            id: indexId,
            data: duplicateRowData,
          });
        }
        this.duplicateExpandedRowData = JSON.stringify(
          this.deepCloneExpandedRowData
        );
        const series = [...this.state.series];
        const seriesIndex = series.findIndex((e) => e.id === indexId);
        if (seriesIndex === -1) {
          series.push({
            id: indexId,
            data: trendData,
          });
        } else {
          const seriesObj = {
            id: indexId,
            data: trendData,
          }
          series[seriesIndex] = seriesObj;
        }
        this.setState({
          expandedRowData,
          series,
        });
      })
      .catch((error) =>
        triggerNotifications.errors(error.message, error.data).then()
      );
  };

  private calculatedPosition = (
    instrumentId: string,
    propertyId: string,
    directionId: string,
    propertyName: string
  ) => {
    sampleActions
      .getCalculatedPropertyPosition(this.state.measurementId, propertyId)
      .then(() => {
        const indexId = propertyId + "-" + instrumentId + "-" + directionId;
        if (this._calculatedPositionData !== null) {
          const dt = {
            ...this._calculatedPositionData,
            id: indexId,
            propertyType: PropertyType.CALCULATED,
          };
          let item = this.state.reportData.find((items) => {
            return items.name === propertyName;
          });
          const trendData = this.generateOrdinalData3(dt, item);
          const expandedRowData = [...this.state.expandedRowData];
          expandedRowData.push({
            id: indexId,
            data: [dt],
          });
          this.deepCloneExpandedRowData.push({
            id: indexId,
            data: [dt],
          });
          this.duplicateExpandedRowData = JSON.stringify(
            this.deepCloneExpandedRowData
          );
          const series = [...this.state.series];
          const seriesIndex = series.findIndex((e) => e.id === indexId);
          if (seriesIndex === -1) {
            series.push({
              id: indexId,
              data: trendData,
            });
          } else {
            const seriesObj = {
              id: indexId,
              data: trendData,
            }
            series[seriesIndex] = seriesObj;
          }
          this.setState({
            expandedRowData,
            series,
          });
        }
      })
      .catch((error) =>
        triggerNotifications.errors(error.message, error.data).then()
      );
  };

  private editMeasuredSample = () => {
    this.props.showToastMessage(true);
    const request: IEditSampleMeasurement = this.editMeasuredSampleReq;
    sampleActions
      .editSampleMeasurement(request, uuidv4())
      .then((data) => {
        this.props.showToastMessage(false);
        if (this._editMeasuredSample) {
          this.measurementOverview();
          this.setState({ expandedRows: [], expandedRowData: [] });
          this.propertyDetailsArray = [];
          this.editMeasuredSampleReq = {};
          this.deepCloneExpandedRowData = [];
          this.setState({ editMeasuredData: true });
          this.setState({ isMeasuredDataEditable: false });
          triggerNotifications.success([CONSTANTS.EDIT_SAMPLE_SUCCESS]);
        }
      })
      .catch((error: any) => {
        this.props.showToastMessage(false);
        this.setState({ editMeasuredData: false });
        this.setState({ isMeasuredDataEditable: true });
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  public setSelectedValueSingle = (v: any) => {
    this.setState({ selectedValueSingle: v });
  };

  private handleClickOutside = (event: any) => {
    if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
      if (
        this.saveWrapperRef &&
        !this.saveWrapperRef.current.contains(event.target)
      ) {
        event.preventDefault();
        event.stopPropagation();
        this.setState({ showEditedValuesLost: true },
        () => {
          document.body.removeEventListener("mousedown", this.handleClickOutside);
        })
      } else {
        this.setState({ showEditedValuesLost: false })
      }
    }
  };

  public editMeasuredDataHandler = () => {
    this.setState({ editMeasuredData: false });
    this.setState({ isMeasuredDataEditable: true });
    this.setSelectedValueSingle([0]);
    document.body.addEventListener("mousedown", this.handleClickOutside);
  };

  public emptyValueCheck = (
    e: any,
    data: any,
    positionData: any,
    propertyData: any
  ) => {
    let propertyDetailsData: IPropertyDetail = InitiaDataReq;
    let newValueData =
      e.target.value === "" ? null : parseFloat(e.target.value);
    const oldCountData = JSON.parse(this.duplicateExpandedRowData);
    const propertyUniqueId = propertyData.id + "-" + propertyData.instrumentId + "-" + propertyData.directionId;
    const oldCount = oldCountData
      .find((x: any) => x.id === propertyUniqueId)
      .data.find((y: any) => y.position === positionData.position)
      .positionValues.find((z: any) => z.count === data.countValue);
    const oldValueData = oldCount === undefined ? null : oldCount.value;
    const measurementId = this.props.activeMeasurementId
      ? this.props.activeMeasurementId
      : this.props.activeItem.measurement;
    propertyDetailsData = {
      id: propertyData.id,
      name: propertyData.name,
      directionId: propertyData.directionId,
      positionDetails: [
        {
          positionName: positionData.positionName,
          position: positionData.position,
          mean: positionData.positionMean,
          positionValues: [
            {
              oldValue: oldValueData,
              newValue: newValueData,
              count: data.countValue,
              valueRangeStatusId: data.valueRangeStatusId,
              valueRangeStatus: data.valueRangeStatus,
            },
          ],
        },
      ],
    };
    let tempFilteredArray;
    tempFilteredArray =
      this.propertyDetailsArray !== undefined
        ? this.propertyDetailsArray
            .filter((x: any) => x.id === propertyData.id && x.directionId === propertyData.directionId)
            .filter((y: any) =>
              y.positionDetails.find(
                (z: any) => z.position === positionData.position
              )
            )
            .filter((v: any) =>
              v.positionDetails[0].positionValues.find(
                (u: any) => u.count === data.countValue
              )
            )
        : [];
    if (oldValueData !== newValueData) {
      if (this.propertyDetailsArray.length !== 0) {
        if (this.propertyDetailsArray !== undefined) {
          if (tempFilteredArray.length === 0) {
            this.propertyDetailsArray.push(propertyDetailsData);
          } else {
            const index = this.propertyDetailsArray.indexOf(
              tempFilteredArray[0]
            );
            this.propertyDetailsArray.splice(index, 1, propertyDetailsData);
          }
        }
      } else {
        this.propertyDetailsArray.push(propertyDetailsData);
      }
    } else {
      if (this.propertyDetailsArray.length !== 0) {
        if (tempFilteredArray.length !== 0) {
          const index = this.propertyDetailsArray.indexOf(tempFilteredArray[0]);
          this.propertyDetailsArray.splice(index, 1);
        }
      }
    }
    this.editMeasuredSampleReq = {
      sampleId: this.props.activeItem.id,
      measurementId: measurementId,
      propertyDetail: this.propertyDetailsArray,
    };
  };

  public saveMeasuredDataHandler = () => {
    if (
      this.state.isCountValuesEdited &&
      this.editMeasuredSampleReq?.hasOwnProperty("propertyDetail") &&
      this.editMeasuredSampleReq?.propertyDetail.length !== 0
    ) {
      this.setState({ saveEditedMeasuredData: true });
    } else {
      this.setState({ editMeasuredData: true });
      this.setState({ isMeasuredDataEditable: false });
      triggerNotifications.info(CONSTANTS.NONE_EDITED);
    }
    document.body.removeEventListener("mousedown", this.handleClickOutside);
  };

  private saveEditedMeasuredDataCancelClick = () => {
    this.setState({ isMeasuredDataEditable: false });
    this.setState({ saveEditedMeasuredData: false });
    this.setState({ editMeasuredData: true });
    this.setState({
      expandedRowData: JSON.parse(this.duplicateExpandedRowData),
    });
    this.propertyDetailsArray = [];
    this.editMeasuredSampleReq = {};
  };

  private saveEditedMeasuredDataClick = () => {
    this.setState({ saveEditedMeasuredData: false });
    if (
      this.editMeasuredSampleReq.hasOwnProperty("propertyDetail") &&
      this.editMeasuredSampleReq.propertyDetail.length !== 0
    ) {
      this.editMeasuredSample();
    }
  };

  private dlgLostClick = () => {
    document.body.addEventListener("mousedown", this.handleClickOutside);
    this.setState({ showEditedValuesLost: false });
  };

  private searchHandler = (e: any) => {
    const value = e.target.value;
    this.setState({
      searchValue: value,
    });
  };

  private setDirectionDropdown = (e: any) => {
    this.setState({
      selectedDirection: e,
    });
  };

  public uniqueSummaryData = (array: any) => {
    let filteredArray = [];
    filteredArray = array?.filter((obj: any, index: any) => {
        return index === array.findIndex((i:any) => `${obj.id}-${obj.instrumentId}-${obj.directionId}` === `${i.id}-${i.instrumentId}-${i.directionId}`)
    })
    return filteredArray;
  }

  public render() {
    let summaryData = this.state.reportData;
    if (this.state.searchValue) {
      const filteredData = summaryData.filter((elements: any) => {
        return elements.name
          .toLowerCase()
          .includes(this.state.searchValue.toLowerCase());
      });
      summaryData = filteredData;
    }
    if (
      this.state.selectedDirection &&
      this.state.selectedDirection.length &&
      this.state.selectedDirection[0].value !== this._All
    ) {
      const filteredData = summaryData.filter((ele) => {
        return ele.directionId === this.state.selectedDirection[0].value;
      });
      summaryData = filteredData;
    }
    summaryData = this.uniqueSummaryData(summaryData)
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="mt-2 summary">
              <div className="summary-text">
                <div className="d-inline-block">
                  {t(CONSTANTS.MODULE_PROPERTY + " " + CONSTANTS.LABEL_SUMMARY)}
                </div>

                <ul
                  className="navbar-nav propertyFilterList"
                  style={{ marginRight: "16px" }}
                >
                  <li className="position-relative summary-filter">
                    <button title="Search" className="searchIcon icon-button">
                      <Icon name="abb/search" sizeClass="small" />
                    </button>
                    <input
                      type="text"
                      className="searchInput"
                      placeholder={t(CONSTANTS.LABEL_SEARCH_PROPERTY)}
                      value={this.state.searchValue}
                      onChange={this.searchHandler}
                    />
                  </li>
                  <li className="position-relative summary-filter" style={{fontWeight: "normal"}}>
                    <Dropdown
                      placeholder={t("Select Direction")}
                      value={this.state.selectedDirection}
                      onChange={(val) => this.setDirectionDropdown(val)}
                      initialOpen={false}
                      className="searchDropdown"
                    >
                      {this.state.dropdownDirectionOptions.map((o: any) => (
                        <DropdownOption
                          key={o.value}
                          label={o.label}
                          value={o.value}
                        />
                      ))}
                    </Dropdown>
                  </li>
                  <li className="position-relative summary-filter">
                    {this.state.selectedValueSingle[0] === 1 ? (
                      <button
                        title={t(CONSTANTS.TITLE_TESTOVERVIEW_DETAILS)}
                        className={
                          this.state.selectedValueSingle[0] === 1
                            ? "icon-button circle active"
                            : "icon-button circle"
                        }
                        onClick={() => this.setSelectedValueSingle([0])}
                      >
                        <Icon name="abb/list" sizeClass="small" />
                      </button>
                    ) : (
                      <button
                        title={t(CONSTANTS.TITLE_TESTOVERVIEW_GRAPH)}
                        className={
                          this.state.selectedValueSingle[0] === 1
                            ? "icon-button circle active"
                            : "icon-button circle"
                        }
                        onClick={() => this.setSelectedValueSingle([1])}
                      >
                        <Icon name="abb/trend-3" sizeClass="small" />
                      </button>
                    )}
                  </li>
                  {this.props.activeItem?.status.name ===
                    CONSTANTS.MEASURED && (
                    <Authorize scopes={[`${CONSTANTS.AUTHKEY_SAMPLE_MODE}:EditMeasurement`]}>
                    <li className="position-relative summary-filter">
                      {this.state.editMeasuredData ? (
                        <button
                          title={t(CONSTANTS.EDIT)}
                          className={"icon-button circle"}
                          onClick={this.editMeasuredDataHandler}
                        >
                          <Icon name="abb/edit" sizeClass="small" />
                        </button>
                      ) : (
                        <button
                          ref={this.saveWrapperRef}
                          title={t(CONSTANTS.BUTTON_SAVE)}
                          className={"icon-button circle active"}
                          onClick={() => this.saveMeasuredDataHandler()}
                          style={{ background: "#3366FF", color: "white" }}
                        >
                          <Icon name="abb/check-mark" sizeClass="small" />
                        </button>
                      )}
                    </li>
                    </Authorize>
                  )}
                </ul>
              </div>

              <div className="header-underline" />
              <div className="w-100">
                <div className="p-4">
                  <div className="abb-wrapper" ref={this.wrapperRef}>
                    <div className="abb-scroller">
                      <table className="abb-report-table w-100 report-sum-table sample-summary-page">
                        <thead>
                          <tr>
                            <th className="row-data-toggle" />
                            <th className="row-data row-data-pad property-col">
                              {t("Property Name")}
                            </th>
                            <th className="row-data row-data-pad">{t("Unit")}</th>
                            <th className="row-data row-data-pad">{t("Mean")}</th>
                            <th className="row-data row-data-pad">{t("Std Dev")}</th>
                            <th className="row-data row-data-pad">{t("MIN")}</th>
                            <th className="row-data row-data-pad">{t("MAX")}</th>
                            <th className="row-data row-data-pad">{t("OK")}</th>
                            <th className="row-data row-data-pad">{t("Alarm1")}</th>
                            <th className="row-data row-data-pad">{t("Alarm2")}</th>
                            <th className="row-data row-data-pad">{t("REJECT")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {summaryData?.map((item, index) => {
                            return this.renderItem(item, index);
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <Dialog
                isOpen={this.state.saveEditedMeasuredData}
                onClose={() => this.setState({ saveEditedMeasuredData: false })}
                showCloseButton={true}
                closeOnEscape={false}
                closeOnLostFocus={false}
                dimBackground={true}
                title={t(CONSTANTS.LABEL_OVERWRITE_MEASURED_VALUE)}
                standardButtonsOnBottom={[
                  {
                    text: t(CONSTANTS.BUTTON_CANCEL),
                    type: "discreet-blue",
                    handler: () => this.saveEditedMeasuredDataCancelClick(),
                  },
                  {
                    text: t(CONSTANTS.BUTTON_OK),
                    type: "primary-blue",
                    handler: this.saveEditedMeasuredDataClick,
                  },
                ]}
              >
                <div>
                  {t(CONSTANTS.LABEL_OVERWRITE_MEASURED_VALUE_CONFIRM)}
                  <br />
                  <br />
                  {t(CONSTANTS.MEASURED_VALUE_LOST_MESSAGE)}
                </div>
              </Dialog>
              <div id="popupValueLost">
                <Dialog
                  isOpen={this.state.showEditedValuesLost}
                  onClose={() => this.dlgLostClick()}
                  showCloseButton={true}
                  closeOnEscape={false}
                  closeOnLostFocus={false}
                  dimBackground={true}
                  title={t(CONSTANTS.EDITED_MEASURED_VALUES_LOST)}
                  standardButtonsOnBottom={[
                    {
                      text: t(CONSTANTS.BUTTON_OK),
                      type: "primary-blue",
                      handler: () => this.dlgLostClick(),
                    },
                  ]}
                />
              </div>
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
